/* eslint-disable no-nested-ternary */
import React, { FC, memo } from 'react';
import { styled } from 'linaria/react';
import Image from 'next/image';
import { useTheme, withTheme } from '@shared/lib';
import { currencySymbols, STEAM_COURSE } from '@shared/config';
import { OldSpinner } from '@shared/ui/atoms';
import { ICourseSteam } from '../model/payment.types';
interface Props {
  courseSteam: ICourseSteam | null;
  label?: string;
  icon?: string;
  tooltip?: React.ReactElement;
  error?: boolean;
  activeCountrySteam?: string;
  loading?: boolean;
}
export const CyberCourseSteam: FC<Props> = memo(({
  courseSteam,
  loading,
  label,
  icon,
  tooltip,
  error,
  activeCountrySteam
}) => {
  const theme = useTheme();
  const getCurrency = country => {
    switch (country) {
      case 'Страны СНГ':
        return 'USD';
      case 'Казахстан':
        return 'KZT';
      default:
        return 'RUB';
    }
  };
  const getPlaceholder = country => {
    const placeholders = {
      'Страны СНГ': `от 3 ${currencySymbols[getCurrency(country)]}`,
      Казахстан: `от 1700 ${currencySymbols[getCurrency(country)]}`,
      default: `от 325 ${currencySymbols[getCurrency(country)]}`
    };
    return placeholders[country] || placeholders.default;
  };
  const getValueCourse = (courseSteam, country) => {
    switch (country) {
      case 'Страны СНГ':
        return courseSteam?.usd_topup;
      case 'Казахстан':
        return courseSteam?.kzt_topup;
      default:
        return courseSteam?.rub_topup;
    }
  };
  const currency = getCurrency(activeCountrySteam);
  const placeholder = getPlaceholder(activeCountrySteam);
  const valueCourse = getValueCourse(courseSteam, activeCountrySteam);
  return <Wrapper>
        {label && <Text>{label}</Text>}
        <WrapperInner error={error}>
          <Flex>
            {icon ? <Image src={icon} alt="icon" height={24} width={24} style={{
          borderRadius: '8px'
        }} /> : <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" style={{
          borderRadius: '9.846px'
        }}>
                <g clipPath="url(#clip0_9723_8748)">
                  <rect width="32" height="32" fill="url(#paint0_linear_9723_8748)" />
                  <path d="M15.0551 12.117L15.0566 12.1955L11.1674 17.8526C10.5375 17.8238 9.90573 17.9347 9.30571 18.1819C9.04451 18.2881 8.79513 18.4215 8.56164 18.5797L0.0207998 15.0552C0.0207998 15.0552 -0.176889 18.3107 0.646648 20.7366L6.6846 23.2312C6.98262 24.5879 7.91642 25.7775 9.28832 26.3495C10.3676 26.7985 11.5808 26.8002 12.6614 26.3543C13.742 25.9084 14.6017 25.0513 15.0516 23.9712C15.2916 23.3959 15.4074 22.7763 15.3913 22.153L20.951 18.1719L21.0876 18.1744C24.418 18.1744 27.125 15.456 27.125 12.117C27.125 8.77791 24.4229 6.06946 21.0876 6.0625C17.7586 6.0625 15.0501 8.77791 15.0501 12.117H15.0551ZM14.1213 23.5803C13.3991 25.321 11.4063 26.1401 9.67426 25.4175C8.90567 25.094 8.28268 24.499 7.92387 23.7455L9.88934 24.5611C10.193 24.6876 10.5185 24.753 10.8474 24.7535C11.1763 24.7541 11.502 24.6897 11.8061 24.5641C12.1101 24.4385 12.3864 24.2542 12.6193 24.0217C12.8521 23.7891 13.0369 23.5129 13.1631 23.2088C13.4187 22.5944 13.4202 21.9035 13.1673 21.288C12.9145 20.6725 12.4279 20.1826 11.8146 19.926L9.77808 19.083C10.5619 18.7846 11.453 18.7747 12.2864 19.1213C13.1308 19.4709 13.7766 20.1294 14.1223 20.9714C14.468 21.8133 14.466 22.7419 14.1173 23.5803M21.093 16.1528C20.0258 16.1499 19.0033 15.7236 18.2494 14.9673C17.4954 14.2111 17.0716 13.1865 17.0707 12.118C17.0719 11.0496 17.4958 10.0252 18.2497 9.2692C19.0036 8.51315 20.026 8.08703 21.093 8.08413C22.1602 8.08677 23.1828 8.51277 23.937 9.26885C24.6911 10.0249 25.1151 11.0494 25.1163 12.118C25.1154 13.1867 24.6914 14.2114 23.9373 14.9677C23.1832 15.724 22.1604 16.1501 21.093 16.1528ZM18.079 12.1115C18.0784 11.3087 18.3961 10.5384 18.9624 9.97001C19.5286 9.40162 20.2971 9.0816 21.099 9.08028C22.7654 9.08028 24.1209 10.438 24.1209 12.1115C24.1213 12.9145 23.8032 13.6848 23.2365 14.253C22.6698 14.8213 21.901 15.1409 21.099 15.1417C20.2972 15.1405 19.5287 14.8207 18.9624 14.2525C18.396 13.6843 18.0781 12.9142 18.0785 12.1115H18.079Z" fill={theme.colors.icon.white} />
                </g>
                <defs>
                  <linearGradient id="paint0_linear_9723_8748" x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#111D2E" />
                    <stop offset="0.212" stopColor="#051839" />
                    <stop offset="0.407" stopColor="#0A1B48" />
                    <stop offset="0.581" stopColor="#132E62" />
                    <stop offset="0.738" stopColor="#144B7E" />
                    <stop offset="0.873" stopColor="#136497" />
                    <stop offset="1" stopColor="#1387B8" />
                  </linearGradient>
                  <clipPath id="clip0_9723_8748">
                    <rect width="32" height="32" fill={theme.colors.icon.primary} />
                  </clipPath>
                </defs>
              </svg>}
            {loading ? <OldSpinner small /> : courseSteam?.rub_topup ? <TextInput>
                ~ {valueCourse} {currencySymbols[currency]}
              </TextInput> : <Placeholder>{placeholder}</Placeholder>}
          </Flex>
          {tooltip && <>{tooltip}</>}
        </WrapperInner>
        {error && <TextError>{STEAM_COURSE}</TextError>}
      </Wrapper>;
});
interface TextProps {
  isActive?: boolean;
}
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxs;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxs;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const Text = withTheme(/*#__PURE__*/styled('div')({
  name: "Text",
  class: "t1vj2pf",
  propsAsIs: false,
  vars: {
    "t1vj2pf-0": [_exp()],
    "t1vj2pf-1": [_exp2(), "px"],
    "t1vj2pf-2": [_exp3()],
    "t1vj2pf-3": [_exp4(), "px"],
    "t1vj2pf-4": [_exp5()]
  }
}));
interface TextInputProps {
  isActive?: boolean;
}
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.sm;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const TextInput = withTheme(/*#__PURE__*/styled('div')({
  name: "TextInput",
  class: "t1giqx8v",
  propsAsIs: false,
  vars: {
    "t1giqx8v-0": [_exp6()],
    "t1giqx8v-1": [_exp7(), "px"],
    "t1giqx8v-2": [_exp8()],
    "t1giqx8v-3": [_exp9(), "px"],
    "t1giqx8v-4": [_exp0()]
  }
}));
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wmssva7",
  propsAsIs: false
});
interface WrapperInnerProps {
  error?: boolean;
}
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.tertiary;
const _exp10 = /*#__PURE__*/() => ({
  error,
  theme
}) => error ? theme.colors.state.active : theme.colors.state.autocompleteBorder;
const _exp11 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const WrapperInner = withTheme(/*#__PURE__*/styled('div')({
  name: "WrapperInner",
  class: "w1p0gzon",
  propsAsIs: false,
  vars: {
    "w1p0gzon-0": [_exp1()],
    "w1p0gzon-1": [_exp10()],
    "w1p0gzon-2": [_exp11()]
  }
}));
const _exp12 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xxxs;
const _exp13 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp14 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xxs;
const _exp15 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.active;
const TextError = withTheme(/*#__PURE__*/styled('div')({
  name: "TextError",
  class: "t3z1ub6",
  propsAsIs: false,
  vars: {
    "t3z1ub6-0": [_exp12(), "px"],
    "t3z1ub6-1": [_exp13()],
    "t3z1ub6-2": [_exp14(), "px"],
    "t3z1ub6-3": [_exp15()]
  }
}));
const _exp16 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp17 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp18 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp19 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.secondary;
const Placeholder = withTheme(/*#__PURE__*/styled('div')({
  name: "Placeholder",
  class: "pi3krrd",
  propsAsIs: false,
  vars: {
    "pi3krrd-0": [_exp16(), "px"],
    "pi3krrd-1": [_exp17()],
    "pi3krrd-2": [_exp18(), "px"],
    "pi3krrd-3": [_exp19()]
  }
}));
const Flex = /*#__PURE__*/styled('div')({
  name: "Flex",
  class: "f1567fqa",
  propsAsIs: false
});

require("./CyberCourseSteam.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./CyberCourseSteam.tsx");